// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"788372e1","524":"bce0ef3e","536":"267d2090","694":"588a7adb"}[chunkId] + ".chunk.css";
};